export enum TabsTypeEnum {
  ALL = "all",
  RENDERING = "rendering",
  QCOUPON = "qcoupon",
  FREE = "free",
}

export enum CouponType {
  ALL = -1,
  Animation,
  Qing,
  RenderingMember,
  Expired,
  Desktop = 8,
}

export enum CouponStatus {
  All = -1,
  BeUsable,
  Expired,
}

export const CouponTypeMap = new Map([
  [
    CouponType.Desktop,
    {
      type: CouponType.Desktop,
      color: "var(--color-coupon)",
      subColor: "var(--color-coupon-sub)",
      tabBgColor: "var(--color-coupon-tab-bg)",
      contentBg: "var(--color-coupon-content-bg)",
      contentTitleColor: "var(--color-coupon-content-title)",
      contentColor: "var(--color-coupon-content)",
      borderColor: "var(--color-coupon-border)",
      buttonColor: "var(--color-coupon-button)",
      buttonBg: "var(--color-coupon-button-bg)",
    },
  ],
  [
    CouponType.Expired,
    {
      type: CouponType.Expired,
      color: "#919499",
      subColor: "#1A865F",
      tabBgColor: "rgba(145, 148, 153, 0.14)",
      contentBg: "rgba(255, 255, 255, 0.8)",
      contentTitleColor: "#5EAD8D",
      contentColor: "#227A56",
    },
  ],
]);

export const CouponContentMap = new Map([
  [
    CouponType.Desktop,
    {
      type: CouponType.Desktop,
      color: "#00B849",
      text: "coupon_apply_to_animation",
    },
  ],
]);
